import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useCatalogByIdQuery } from '../../api/hooks/catalogs';
import dayjs from 'dayjs';
import CatalogProductsView from './CatalogProductsView';
import CheckoutModal from './CheckoutModal';

const CatalogView = () => {
  const navigate = useNavigate();
  const { merchantId, catalogId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const { data, isLoading } = useCatalogByIdQuery({ merchantId, catalogId });
  const checkoutSuccess = Boolean(searchParams.get('checkout-success'));

  if (isLoading || !data) return <CircularProgress />;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 4 }}>
        <Stack direction="row">
          <Stack>
            <Typography variant="h1">{data.name}</Typography>

            <Typography variant="caption">
              Availabile for import:{' '}
              {data.availability_start ? (
                <>
                  {dayjs(data.availability_start).format('MM/DD/YYYY')}-
                  {dayjs(data.availability_end).format('MM/DD/YYYY')}
                </>
              ) : (
                'Always'
              )}
            </Typography>
          </Stack>
          {data.activated ? (
            <Chip label="Active" color="primary" sx={{ m: 2 }} />
          ) : (
            <Button onClick={() => navigate('./edit')} sx={{ mx: 2 }}>
              Edit
            </Button>
          )}
        </Stack>
        <Stack direction="row" spacing={2} height="min-content">
          <Button onClick={() => navigate('../..', { relative: 'path' })}>
            Back
          </Button>
          {!data.activated && (
            <Button variant="outlined" onClick={() => navigate('./activate')}>
              Activate
            </Button>
          )}
          <Button
            variant="flat"
            disabled={data.activated}
            onClick={() => navigate('./add-products')}
          >
            Add Products
          </Button>
        </Stack>
      </Stack>
      <CatalogProductsView />
      <CheckoutModal open={pathname.includes('activate')} />
      <Dialog open={checkoutSuccess} sx={{ textAlign: 'center' }}>
        <DialogTitle>Catalog Activated</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            This catalog has been activated and is now available for import.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="flat" onClick={() => setSearchParams({})}>
            Go to Catalog
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CatalogView;
